import classes from './Button.module.scss';

function Button(props) {
    const btnClasses = `${classes.button} ${props.isFilled ? classes.filled : ''}`;

    return (
        <button onClick={props.onBtnClick} className={btnClasses} disabled={props.disabled}> {props.children} </button>
    )
}

export default Button
